export const blockIconsUiactionsRemoveNew = (
	<span className='material-symbols-outlined'>remove</span>
);
